import { PersonBadge } from '@/models/PersonBadge';
import { action } from 'typesafe-actions';
import { AchievementsTypes } from './types';

export const updateAchievementsNotificationRequest = (personBadgeId: number) =>
    action(AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_REQUEST, personBadgeId);
export const updateAchievementsNotificationSuccess = () => action(AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_SUCCESS);
export const updateAchievementsNotificationFailure = () => action(AchievementsTypes.UPDATE_ACHIEVEMENTS_NOTIFICATION_FAILURE);

export const updateAchievementsInfoRequest = () => action(AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_REQUEST);
export const updateAchievementsInfoSuccess = () => action(AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_SUCCESS);
export const updateAchievementsInfoFailure = () => action(AchievementsTypes.UPDATE_ACHIEVEMENTS_INFO_FAILURE);

export const listAchievementsRequest = (personId: number) => action(AchievementsTypes.LIST_ACHIEVEMENTS_REQUEST, personId);
export const listAchievementsSuccess = (achievements: PersonBadge[]) => action(AchievementsTypes.LIST_ACHIEVEMENTS_SUCCESS, achievements);
export const listAchievementsFailure = () => action(AchievementsTypes.LIST_ACHIEVEMENTS_FAILURE);
